var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "custom-class": "mapping-code-selector",
        width: _vm.isDepartment ? "800px" : "600px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: { inline: true, "label-position": "left" },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _vm.isDepartment
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "el-form-item-filter",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.isZh
                              ? _vm.$store.getters.currentOffice.chineseName
                              : _vm.$store.getters.currentOffice.englishName,
                            placement: "bottom"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "company-select",
                              on: { mousemove: _vm.handleCompanyMousemove }
                            },
                            [
                              _vm.$store.getters.userInfo.groupCompany
                                ? _c(
                                    "el-select",
                                    {
                                      ref: "companySelect",
                                      staticClass: "navbar-company-selector",
                                      attrs: {
                                        "popper-class":
                                          "navbar-company-selector-popper",
                                        filterable: ""
                                      },
                                      on: { change: _vm.handleCompany },
                                      model: {
                                        value: _vm.currentOfficeId,
                                        callback: function($$v) {
                                          _vm.currentOfficeId = $$v
                                        },
                                        expression: "currentOfficeId"
                                      }
                                    },
                                    _vm._l(_vm.currentOfficeList, function(
                                      office
                                    ) {
                                      return _c(
                                        "el-tooltip",
                                        {
                                          key: office.uuid,
                                          attrs: {
                                            content: _vm.isZh
                                              ? office.chineseName
                                              : office.englishName,
                                            placement: "left"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              value: office.officeId,
                                              label: office.code
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "el-form-item-filter",
                  attrs: { label: _vm.lbType }
                },
                [
                  _c("el-input", {
                    on: { input: _vm.filterChangeHandler },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.filterChangeHandler($event)
                      }
                    },
                    model: {
                      value: _vm.txtFilter,
                      callback: function($$v) {
                        _vm.txtFilter = $$v
                      },
                      expression: "txtFilter"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "show-side-bar": false,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "min-height": "320px"
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirmHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c("el-button", { on: { click: _vm.cancelHandler } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }